import React from 'react';
import { useMediaQuery } from 'react-responsive';
import DomainResults from '../../presentation/DomainResults/DomainResults';
import HomepageContent from './HomepageContent';

const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 768 });
  return isDesktop ? children : null;
};

const DesktopResponsive = ({
  open,
  domainName,
  handleKeyDown,
  handleDomainOpen,
  handleOnChange,
}) => (
  <Desktop>
    {open ? (
      <DomainResults domainName={domainName} />
    ) : (
      <HomepageContent
        domainName={domainName}
        handleKeyDown={handleKeyDown}
        handleDomainOpen={handleDomainOpen}
        handleOnChange={handleOnChange}
      />
    )}
  </Desktop>
);

export default DesktopResponsive;
